import { render, staticRenderFns } from "./receiveInfoVerifyQuery.vue?vue&type=template&id=cc581072&scoped=true"
import script from "./receiveInfoVerifyQuery.vue?vue&type=script&lang=js"
export * from "./receiveInfoVerifyQuery.vue?vue&type=script&lang=js"
import style0 from "./receiveInfoVerifyQuery.vue?vue&type=style&index=0&id=cc581072&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc581072",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc581072')) {
      api.createRecord('cc581072', component.options)
    } else {
      api.reload('cc581072', component.options)
    }
    module.hot.accept("./receiveInfoVerifyQuery.vue?vue&type=template&id=cc581072&scoped=true", function () {
      api.rerender('cc581072', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/Confirm/receiveInfoVerifyQuery.vue"
export default component.exports